export default __webpack_public_path__ + "static/media/img-slider-ommerchant-6.bef526c9.png";